// extracted by mini-css-extract-plugin
module.exports = {"attribute":"attribute_attribute__1MI7s","label":"attribute_label__3N7Zr","icon":"attribute_icon__vANzg","text":"attribute_text__16T-X","bar":"attribute_bar__3AzOb"};